export const style = {
  wrapper: {
    border: `1px solid #666`
  },
  header: {
    background: `#f6f6f6`
  },
  authorSpan: {
    color: `black`
  },
  reply: {
    border: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/ColorBlind/tickets.js